import { CurrentUserIndexResponse } from "./currentUser";

export interface SessionsCreateParams {
  email: string;
  password: string;
}

export type SessionsCreateResponse = CurrentUserIndexResponse;

export const sessionsCreateQuery = (params: SessionsCreateParams) => ({
  url: "/api/login",
  method: "POST",
  body: { user: params },
});

export const sessionsDestroyQuery = () => ({
  url: "/api/logout",
  method: "DELETE",
});
